export default __webpack_public_path__ + "sort-down.png";